<div class="container">
    <button [ngClass]="{'blue-stroked-button': buttonReplace, 'blue-flat-button': !buttonReplace, 'mat-button': isImportButtonEnable, 'disabled': !isImportButtonEnable}"  id="product-import-file-button-wrapper" (click)="input.click()" [disabled]="!isImportButtonEnable ? true : null">
        <input type="file" id="product-import-file-button-input-file" #input
            accept=".xlsx,.xls,.csv" (change)="importFile($event)"
        >
        <mat-icon>upload</mat-icon>
        <span class="title-btn">{{ buttonReplace ? ('product.import.change-file' | translate) : ('product.import.import-file' | translate) }}</span>
    </button>
    <button mat-button id="product-import-history-button" class="mat-button blue-subtle-button no-padding" *ngIf="showHistoryButton" (click)="openDialog($event)">
        <mat-icon>history</mat-icon>
    </button>
</div>